// import { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";

// import DeviceReports from "./DeviceReports";
// import SiteReports from "./SiteReports";
// import UserReports from "./UserReports";

// export default function Reports() {
//   const [activeTab, setActiveTab] = useState(0);

//   const role = localStorage.getItem("role");

//   // Hide User Reports only for Site Engineer
//   const tabs = [
//     {
//       label: "Device Reports",
//       component: <DeviceReports />,
//     },
//     {
//       label: "Site Reports",
//       component: <SiteReports />,
//     },
//     ...(role !== "SE" && role !== "CA"
//       ? [
//           {
//             label: "User Reports",
//             component: <UserReports />,
//           },
//         ]
//       : []),
//   ];

//   return (
//     <Box sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}>
//       {/* Tabs */}
//       <Card
//         sx={{
//           mb: 2,
//           borderRadius: 3,
//           boxShadow: 4,
//           overflow: "hidden",
//         }}
//       >
//         <Tabs
//           value={activeTab}
//           onChange={(e, newValue) => setActiveTab(newValue)}
//           variant="fullWidth"
//           sx={{
//             "& .MuiTabs-indicator": {
//               backgroundColor: "#EE7F1A",
//               height: 4,
//             },
//           }}
//         >
//           {tabs.map((tab, index) => (
//             <Tab
//               key={index}
//               label={tab.label}
//               sx={{
//                 textTransform: "none",
//                 fontWeight: 600,
//                 fontSize: "15px",
//                 color: "#666",
//                 transition: "0.3s",
//                 "&.Mui-selected": {
//                   color: "#EE7F1A",
//                 },
//               }}
//             />
//           ))}
//         </Tabs>
//       </Card>

//       {/* Content */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeTab}
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           exit={{ opacity: 0, x: -50 }}
//           transition={{ duration: 0.4 }}
//         >
//           {tabs[activeTab]?.component}
//         </motion.div>
//       </AnimatePresence>
//     </Box>
//   );
// }


import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import DeviceReports from "./DeviceReports";
import SiteReports from "./SiteReports";
import UserReports from "./UserReports";

export default function Reports() {
  const [activeTab, setActiveTab] = useState(0);

  const role = localStorage.getItem("role");
  const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Hide User Reports only for Site Engineer
  const tabs = [
    {
      label: "Device Reports",
      component: <DeviceReports />,
    },
    {
      label: "Site Reports",
      component: <SiteReports />,
    },
    ...(role !== "SE" && role !== "CA"
      ? [
          {
            label: "User Reports",
            component: <UserReports />,
          },
        ]
      : []),
  ];

  return (
    <Box sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}>
      {/* Tabs */}
      {/* <Card
        sx={{
          mb: 2,
          borderRadius: 3,
          boxShadow: 4,
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          variant="fullWidth"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#EE7F1A",
              height: 4,
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: "15px",
                color: "#666",
                transition: "0.3s",
                "&.Mui-selected": {
                  color: "#EE7F1A",
                },
              }}
            />
          ))}
        </Tabs>
      </Card> */}

      <Card
  sx={{
    mb: 2,
    borderRadius: 3,
    boxShadow: 4,
  }}
>
  <Tabs
    value={activeTab}
    onChange={(e, newValue) => setActiveTab(newValue)}
    variant={isMobile ? "scrollable" : "fullWidth"}
    // scrollButtons={isMobile ? "auto" : false}
    // allowScrollButtonsMobile
    sx={{
      "& .MuiTabs-indicator": {
        backgroundColor: "#EE7F1A",
        height: 4,
      },
    }}
  >
    {tabs.map((tab, index) => (
      <Tab
        key={index}
        label={tab.label}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          fontSize: "15px",
          color: "#666",
          minWidth: isMobile ? "180px" : "auto",
          "&.Mui-selected": {
            color: "#EE7F1A",
          },
        }}
      />
    ))}
  </Tabs>
</Card>

      {/* Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.4 }}
        >
          {tabs[activeTab]?.component}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}